import {
  push, replace, goBack, goForward,
} from 'connected-react-router';

export function ActionRouteNavigate(location) {
  return push(location);
}

export function ActionRouteForceNavigate(location) {
  return replace(location);
}
export function ActionRouteGoBack() {
  return goBack();
}

export function ActionRouteGoForward() {
  return goForward();
}
